/* eslint-disable @typescript-eslint/ban-types */
import {
  PROPOSAL_AFIRMATIVE,
  PROPOSAL_NEGATIVE,
} from 'components/proposal_types';
import React, { useState } from 'react';
import { useLocation } from 'react-router';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import minusFilled from 'v2//icons/minusFilled.svg';
import chatIcon from 'v2/icons/chatIcon.svg';
import {
  createProposalConversation,
  fetchAllProposals,
  updateProposalAction,
} from '../../../../actions';
import BuyerRejectProposalModal from './BuyerRejectProposalModal';
import { toast } from 'react-toastify';
import { ApiError, buildApiError } from 'v2/utils/restFactory';
import { AxiosError } from 'axios';
import { useQueryClient } from 'react-query';
import { getKey as getSearchConversationCountKey } from 'v2/queries/useSearchConversationCount';

interface SearchResponseActionsOwnProps {
  isThirdPartyResponse: boolean;
  proposalId: number;
  onAccepted: () => void;
  providerName: string;
}

interface DisptachProps {
  updateProposalAction: Function;
  createProposalConversation: Function;
  fetchAllProposals: Function;
}

type SearchResponseActionsProps = SearchResponseActionsOwnProps & DisptachProps;

const SearchResponseActions = ({
  proposalId,
  isThirdPartyResponse,
  createProposalConversation,
  fetchAllProposals,
  updateProposalAction,
  onAccepted,
  providerName,
}: SearchResponseActionsProps) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [isBusy, setIsBusy] = useState(false);
  const location = useLocation();

  const queryClient = useQueryClient();

  const registerResponse = async (
    proposalId: number,
    responseBool: boolean,
    optionId?: number,
    responseReason?: string
  ) => {
    try {
      setIsBusy(true);
      const responseAction = responseBool
        ? PROPOSAL_AFIRMATIVE
        : PROPOSAL_NEGATIVE;

      if (responseBool && !isThirdPartyResponse) {
        await createProposalConversation(proposalId);
        onAccepted();
        queryClient.invalidateQueries([getSearchConversationCountKey(0)[0]]);
      }

      await updateProposalAction(
        proposalId,
        responseAction,
        optionId,
        responseReason
      );
    } catch (error) {
      toast.error(buildApiError(error as AxiosError<ApiError>));
    } finally {
      fetchAllProposals();
      setIsBusy(false);
    }
  };
  const renderActionButtons = () => {
    return (
      <div className="d-flex mt-3">
        <Button
          variant="danger"
          className="mr-3"
          onClick={() => setShowRejectModal(true)}
          disabled={isBusy}
        >
          <img
            className="mr-2"
            src={minusFilled}
            alt="rejectProposalIcon"
          ></img>
          {isThirdPartyResponse ? 'move to rejected' : 'do not proceed'}
        </Button>
        <Button
          variant="secondary"
          onClick={async () => await registerResponse(proposalId, true)}
          disabled={isBusy}
        >
          <img
            className="mr-2"
            src={chatIcon}
            alt="startConversationIcon"
          ></img>
          {isThirdPartyResponse ? 'move to accepted' : 'proceed to chat'}
        </Button>
      </div>
    );
  };

  return (
    <>
      {!location.pathname.includes('/reviewer/') &&
        !location.pathname.includes('/viewer/') &&
        renderActionButtons()}
      <BuyerRejectProposalModal
        reject={async (rejectOption: number, rejectText?: string) => {
          await registerResponse(proposalId, false, rejectOption, rejectText);
          setShowRejectModal(false);
        }}
        show={showRejectModal}
        onHide={() => setShowRejectModal(false)}
        isBusy={isBusy}
        providerName={providerName}
      />
    </>
  );
};

export default connect(null, {
  updateProposalAction,
  createProposalConversation,
  fetchAllProposals,
})(SearchResponseActions);
